/** Терминология Бай.Спорт — единый словарь для UI */
export const L = {
  productName: "Бай.Спорт",
  productTagline: "CRM для спортивных клубов и тренеров",

  organization: "Организация",
  club: "Клуб",
  clubs: "Клубы",
  venue: "Зал",
  venues: "Залы",
  trainer: "Тренер",
  trainers: "Тренеры",
  client: "Клиент",
  clients: "Клиенты",
  athlete: "Спортсмен",
  group: "Группа",
  groups: "Группы",
  direction: "Направление",
  directions: "Направления",
  session: "Занятие",
  sessions: "Занятия",
  schedule: "Календарь",
  journal: "Журнал",
  membership: "Абонемент",
  memberships: "Абонементы",
  membershipPlan: "Тип абонемента",
  payment: "Оплата",
  payments: "Оплаты",
  debtor: "Должник",
  debtors: "Должники",
  event: "Соревнование",
  events: "Соревнования",
  document: "Документ",
  documents: "Документы",

  adminTitle: "Управление клубом",
  today: "Сводка",
  summary: "Сводка",
  openJournal: "Открыть журнал",
  medicalClearance: "Допуск к занятиям",
  clearanceShort: "Допуск",
  rankBelt: "Разряд / пояс",
  cardNumber: "№ карточки клуба",

  portalClient: "Личный кабинет",
  portalTrainer: "Кабинет тренера",
  portalAdmin: "Управление клубом",
  owner: "Владелец",
  team: "Команда",
  addStaff: "Добавить сотрудника",

  findClub: "Найти клуб",
  registerClub: "Зарегистрировать клуб",
  forClubs: "Для клубов",
};

export default L;
